import React from 'react'
import logo from '../img/bash.png'

export const Footer = () => {

    return ( 
        <footer className="page-footer">
        <div className="container">
          <div className="row">
            <div className="col l2 s12 typewriter">
              <a href="/" className="brand-logo"><img src={logo} alt="Logo" /></a>
              <h5 className="mui--divider-bottom ">NoSkiddie</h5>
              <p className="grey-text text-lighten-4 typewriter">From a good to better.</p>
            </div>
            <div className="col l2 s12">
            <h5 className="white-text">CONTACTS</h5>
            <ul>
              <li><a className="grey-text text-lighten-3" href="https://github.com/noskiddie">My Git</a></li>
              <li><a className="grey-text text-lighten-3" href="mailto:noskiddie@yandex.com">My E-mail</a></li>
              <li><a className="grey-text text-lighten-3" href="https://keybase.io/noskiddie">My Keybase</a></li>
              <li><a className="grey-text text-lighten-3" href="telegram://t.me/noskiddie">My Telegram</a></li>
            </ul>
            </div>
          </div>
        </div>
        <div className="footer-copyright">
          <div className="container">
          <a className="grey-text text-lighten-4 center" href="#!">©2020-2021 Copyright NoSkiddie</a>
          </div>
        </div>
      </footer>
    )
}

export default Footer